import './GroupByHallNumbers.scss';
import { useAppDispatch } from '../../../redux/store';
import { AppActions } from '../../../redux/AppActions';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/AppReducer';
import { useCallback, useEffect } from 'react';

interface GroupByHallNumbersProps {
	favoriteCount: number;
}

export default function GroupByHallNumbers({ favoriteCount }: GroupByHallNumbersProps) {
	const dispatch = useAppDispatch();
	const isChecked = useSelector((state: RootState) => state.appState.groupByHallNumbers);
	const disabledCheckbox = useSelector((s: RootState) => s.appState.disableGroupByHall);

	useEffect(() => {
		if (isChecked && (favoriteCount === 0 || disabledCheckbox)) {
			dispatch(AppActions.setGroupByHallNumbers(false));
		}
	}, [favoriteCount, isChecked, disabledCheckbox, dispatch]);

	const handleOnChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(AppActions.setGroupByHallNumbers(e.target.checked));
		},
		[dispatch]
	);

	return (
		<div className='group-by-hall-numbers-container'>
			<label htmlFor='groupByHall' className='check-box'>
				<input
					type='checkbox'
					id='groupByHall'
					checked={isChecked}
					onChange={handleOnChange}
					disabled={disabledCheckbox}
				/>
				<span className={`order-by-label ${!isChecked ? 'isUnChecked' : ''}`}>
					Order products by Expo West hall location
				</span>
			</label>
		</div>
	);
}
